import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../utils/updateObject';
import {
  toolkitCategories, initialToolDetailsState
} from '../../utils/categories';

const initialState = {
  category: toolkitCategories,
  toolDetails: {...initialToolDetailsState}
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.ADD_TOOL_CHOOSE_CATEGORY_SUCCESS: return updateObject(state, { toolDetails: {...state.toolDetails, ...action.val}});
    case actionTypes.TOOL_INFO_COMPLETED: return updateObject(state, { toolDetails: {...state.toolDetails, ...action.val}});
    case actionTypes.TOOL_FOCUS_COMPLETED: return updateObject(state, { toolDetails: {...state.toolDetails, ...action.val}});
    case actionTypes.TOOL_LOCATION_AND_CONTACT_COMPLETED: return updateObject(state, { toolDetails: {...state.toolDetails, ...action.val}});
    case actionTypes.TOOL_PRIVACY_SETTINGS_COMPLETED: return updateObject(state, { toolDetails: {...state.toolDetails, ...action.val}});
    case actionTypes.TOOL_GO_BACK_PRESSED: return updateObject(state, { toolDetails: {...state.toolDetails, ...action.val}});
    case actionTypes.ADD_TOOL_SUCCESS: return updateObject(state, { toolDetails: {...action.val}});
    case actionTypes.EDIT_TOOL_SUCCESS: return updateObject(state, { toolDetails: {...action.val}});
    case actionTypes.ADD_TOOL_BACK_TO_EDIT:
      console.log('state----', state)
       return updateObject(state, { toolDetails: {...state.toolDetails, ...action.val}});
    case actionTypes.TOOL_LOADED: return updateObject(state, { toolDetails: {...action.val}});
    case actionTypes.LEAVE_ADD_TOOL: return updateObject(state, { toolDetails: {}});   
    case actionTypes.LEAVE_EDIT_TOOL: return updateObject(state, { toolDetails: {}});  
    case actionTypes.LEAVE_PREVIEW_TOOL: return updateObject(state, { toolDetails: {}});  
    default:
      break;
  }
  return state;
}